module.exports = __webpack_public_path__ + "static/messenger-80c81dd6e44c7247665d0e6bdfcd11fb.png";